module.exports = __webpack_public_path__ + "img/xingneng.068e2c3f.png";